import { Col, Form, Row } from "react-bootstrap";
import DropdownBtn, { Item } from "../../../components/ui/dropdown-btn";
import { useState } from "react";
import { Button } from '@amway/react-components';
import { TranslationFormData } from "../../../resources/translations/translations-model";
import useTranslationList from "../../../resources/translations/translations-hook";

type Props = {
    initial?: TranslationFormData;
    submitLabel: "CREATE" | "UPDATE";
    onSubmit: (data: TranslationFormData) => void;
}

export default function TranslationsToolFormComponent({
    initial,
    submitLabel,
    onSubmit
}: Props) {
    const { locals } = useTranslationList()

    const [selectedLocales, setSelectedLocales] = useState<Item | undefined>(
        initial ? { id: initial.locale, label: initial.locale } : undefined
    );

    const [translateFromValue, setTranslateFromValue] = useState(
        initial?.translateFrom ?? ""
    );

    const [translateToValue, setTranslateToValue] = useState(
        initial?.translateTo ?? ""
    );

    const [localeError, setLocaleError] = useState<string | null>(null);

    let localeTypes: Item[] = locals.map((local) => ({
        id: local,
        label: local,
    }));

    function handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        if (selectedLocales?.label) {
            setLocaleError(null);
            onSubmit({
                locale: selectedLocales!.label,
                translateFrom: translateFromValue,
                translateTo: translateToValue,
            });
        } else {
            setLocaleError("You must select a locale.");
        }
    }

    return (
        <Form className="translation-tool-form" onSubmit={handleSubmit}>
            <Row>
                <Col md={6}>
                    <DropdownBtn
                        id="entry-type-dropdown"
                        required={true}
                        label="Locale type"
                        placeholder="Select the locale"
                        items={localeTypes}
                        value={selectedLocales}
                        onClick={setSelectedLocales as unknown as (item?: Item | null) => void}
                    />
                    {localeError && (
                        <div style={{ color: 'red', fontSize: '0.9em', marginTop: '0.25rem' }}>
                            {localeError}
                        </div>
                    )}
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label htmlFor="rule-value-ctrl">
                            Translate from <sup style={{ color: 'var(--warning-error)' }}>*</sup>
                        </Form.Label>
                        <Form.Control
                            id="rule-value-ctrl"
                            required
                            placeholder="Type the translate from"
                            value={translateFromValue}
                            onChange={e => setTranslateFromValue(e.target.value)}
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label htmlFor="rule-value-ctrl">
                            Translate to
                        </Form.Label>
                        <Form.Control
                            id="rule-value-ctrl"
                            placeholder="Type the translate to"
                            value={translateToValue}
                            onChange={e => setTranslateToValue(e.target.value)}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Col md={2} className="d-flex align-items-end">
                <Button>{submitLabel}</Button>
            </Col>
        </Form>
    )
}